import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import { ShortUrl, type ShortUrlMutation, type ShortUrlMutationVariables } from './getShortUrl.graphql';

// `longUrl` must already have been passed through `getNormalizedLongUrl`.
export async function getShortUrl(longUrl: string, { gql: { fetch } }: UtilityContext): Promise<string> {
	const { data } = await fetch<ShortUrlMutation, ShortUrlMutationVariables>({
		query: ShortUrl,
		variables: {
			url: longUrl,
			hashLength: 10,
		},
		rejectOnError: false,
	});

	if (!data?.shortenLink.shortUrl) {
		throw new Error(`Could not generate short url from ${longUrl} (reason: ${data?.shortenLink.message || 'unknown'})`);
	}
	return data.shortenLink.shortUrl;
}
